import React, { useEffect, useRef } from 'react';
import * as Notifications from 'expo-notifications';
import { useNavigation } from '@react-navigation/native';
import { Subscription } from 'expo-modules-core';

export const NotificationListener: React.FC = () => {
  const navigation = useNavigation();
  const notificationListener = useRef<Subscription>();
  const responseListener = useRef<Subscription>();

  useEffect(() => {
    // Handle notifications that are received while the app is foregrounded
    notificationListener.current = Notifications.addNotificationReceivedListener(notification => {
      const data = notification.request.content.data;
      console.log('Received notification:', data);
    });

    // Handle notifications that are tapped by the user
    responseListener.current = Notifications.addNotificationResponseReceivedListener(response => {
      const data = response.notification.request.content.data;
      console.log('Notification tapped:', data);

      // Navigate to the appropriate screen based on the notification data
      if (data && data.goalId) {
        // @ts-ignore - Navigation typing issue
        navigation.navigate('GoalDetails', { goalId: data.goalId });
      }
    });

    // Cleanup subscription on unmount
    return () => {
      if (notificationListener.current) {
        Notifications.removeNotificationSubscription(notificationListener.current);
      }
      if (responseListener.current) {
        Notifications.removeNotificationSubscription(responseListener.current);
      }
    };
  }, [navigation]);

  return null;
}; 